var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.523438 13.599L0.525032 11.6603L4.69345 7.50027L0.531874 3.33993L0.533469 1.40112L6.63442 7.50027L0.523438 13.599ZM4.53507 11.6603L4.53347 13.599L10.6445 7.50027L4.5435 1.40112L4.54191 3.33993L8.70349 7.50027L4.53507 11.6603ZM8.36864 11.6603L8.36705 13.599L14.478 7.50027L8.37708 1.40112L8.37548 3.33993L12.5371 7.50027L8.36864 11.6603Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrowRight);
export default __webpack_public_path__ + "static/media/navigation_arrow_right.586385278939e47b4d01c91c667df946.svg";
export { ForwardRef as ReactComponent };